import React from 'react';
export function FooterDisclaimer() {
  return <footer className="bg-[#2D2A26] text-[#FAF7F2] py-8 md:py-12 px-4" data-id="element-33">
      <div className="max-w-4xl mx-auto text-center" data-id="element-34">
        <p className="text-xs md:text-sm text-gray-400 leading-relaxed opacity-80" data-id="element-35">
          DISCLAIMER: Contenido educativo, no sustituye consejo médico. Si estás
          embarazada/lactando, tienes diabetes, SII/gastritis severa, enfermedad
          renal/hepática o tomas medicación (especialmente anticoagulantes),
          consulta con un profesional antes.
        </p>
        <div className="mt-6 pt-6 md:mt-8 md:pt-8 border-t border-gray-800 text-xs text-gray-500" data-id="element-36">
          © {new Date().getFullYear()} Barriga Desinflamada. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}